<!-- eslint-disable max-len -->
<template>
  <div id="terms-of-service" class="">
    <h1 align="center">
      ความยินยอมในการเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคล
    </h1>
    <p>&nbsp;</p>
    <ol>
      <li>
        <strong>ผู้ควบคุมข้อมูลส่วนบุคคล</strong>
        <span>
          บริษัท เอสซี แอสเสท คอร์ปอเรชั่น จำกัด (มหาชน) (SC) สำนักงานเลขที่ 1010
          &nbsp;ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร กรุงเทพมหานคร 10900
        </span>
      </li>
      <li>
        <strong>วัตถุประสงค์ของการเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคล</strong>
        <span>
          เจ้าของข้อมูลส่วนบุคคลยินยอมให้ SC และบริษัทในเครือ สามารถเก็บรวบรวม ใช้ หรือ
          เปิดเผยข้อมูลส่วนบุคคลตามสำเนาบัตรประชาชนและทะเบียนบ้านของเจ้าของข้อมูล รวมถึงข้อมูลรายได้สถานที่ติดต่อหมายเลขโทรศัพท์ และ E-mail หรือ Line ID หรือ
          ข้อมูลอื่นใดที่เจ้าของข้อมูลส่วนบุคคลได้มอบและแจ้งไว้ต่อ SC หรือบริษัทในเครือ เพื่อประกอบข้อมูลในการซื้อบ้าน,ที่ดิน,ห้องชุด และผลิตภัณฑ์อื่นใด รวมถึงการใช้บริการต่างๆ  ที่เกี่ยวข้องกับธุรกิจและ
          บริการของ SC หรือบริษัทในเครือ รวมตลอดถึงข้อมูลชีวภาพ ชีวมิติ เช่น ภาพถ่าย ภาพเคลื่อนไหว เสียง ข้อมูลเกี่ยวกับเชื้อชาติ ความเชื่อส่วนบุคคล ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ความพิการ ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม หรือ
          ข้อมูลอื่นใดที่ SC หรือบริษัทในเครือได้รับมาในทุกรูปแบบหรือบันทึกจากการสัมภาษณ์ด้วยวาจา หรือเจ้าของข้อมูลได้ให้ข้อมูลไว้ในแบบสอบถามหรือทางอิเล็คทรอนิกส์ให้สามารถเก็บรวบรวม ใช้หรือ
          เปิดเผยข้อมูลส่วนบุคคลของเจ้าของข้อมูลเพื่อประโยชน์   ในการวิเคราะห์ประมวลผลพัฒนาและใช้ในธุรกิจและบริการของ SC หรือบริษัทในเครืออันอาจเป็นประโยชน์ต่อเจ้าของข้อมูลและ
          ผู้บริโภคได้ โดย SC จะไม่นำข้อมูลไปเปิดเผยให้ต่อบุคคลอื่น เว้นแต่สถาบันการเงินที่เจ้าของข้อมูลประสงค์จะขอสินเชื่อหรือสถาบันการเงินอื่นใด เพื่อประโยชน์ต่อการขอสินเชื่อของเจ้าของข้อมูล และ
          บริษัทคู่ค้าของ SC ที่ร่วมประกอบธุรกิจในการก่อสร้างตกแต่งหรือให้บริการใดๆ ร่วมในธุรกิจของ SC และบริษัทในเครือโดยยินยอมให้สถาบันการเงินหรือบริษัทคู่ค้าของ SC สามารถติดต่อเจ้าของข้อมูลเพื่อการใดๆ ได้ตามวัตถุประสงค์ของสถาบันการเงินและ
          บริษัทคู่ค้าของ SC รวมถึงการเสนอการให้บริการและผลิตภัณฑ์ต่างๆของสถาบันการเงินและบริษัทคู่ค้าของ SC รวมถึงการวิเคราะห์ วิจัยจัดทำข้อมูลทางสถิติเพื่อการปรับปรุงการพัฒนาผลิตภัณฑ์การบริการให้ดียิ่งขึ้น ทั้งนี้รวมถึงการส่งหรือโอนข้อมูลส่วนบุคคลไปยังประเทศปลายทาง                  เพื่อวัตถุประสงค์ที่กล่าวข้างต้นทั้งหมด หรือเป็นการเปิดเผย ตามอำนาจหมายศาล หรือที่กฎหมายกำหนดให้เปิดเผย
        </span>
      </li>
      <li>
        <strong>ระยะเวลาในการเก็บรวบรวมข้อมูลส่วนบุคคล</strong>
        <span>
          SC และบริษัทในเครือจะจัดเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคลตลอดระยะเวลาที่เจ้าของข้อมูล ยัง
          คงเป็นสมาชิกผู้ซื้อบ้าน, ที่ดิน, ห้องชุด หรือผลิตภัณฑ์อื่นใด หรือ
          ใช้บริการในธุรกิจของ SC หรือบริษัทในเครืออยู่หรือในกรณีอื่นๆจนกว่าเจ้าของข้อมูลจะถอนความยินยอม
        </span>
      </li>
      <li>
        <strong>การแจ้งเปลี่ยนแปลงข้อมูลหรือถอนความยินยอม</strong>
        <span>
          เจ้าของข้อมูลส่วนบุคคลสามารถแจ้งเปลี่ยนแปลงข้อมูลส่วนบุคคลให้ถูกต้อง หรือจะถอนความยินยอมเมื่อใดก็ได้โดยแจ้งเป็นลายลักษณ์อักษร
          ให้บริษัทรับทราบเป็นหนังสือหรือ E-mail: dataprivacy@scasset.com หรือโทรศัพท์แจ้งที่ Call Center เบอร์โทร. 1749
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SC จะดำเนินการเปลี่ยนแปลงข้อมูลหรือถอนความยินยอมให้แล้วเสร็จภายใน 30 วัน นับแต่ได้รับแจ้ง โดย
          การถอนความยินยอมเจ้าของข้อมูล จะมีผลกระทบต่อการใช้บริการของ SC และบริษัทในเครือที่เกี่ยวข้องในทุกด้านที่เจ้าของข้อมูลส่วนบุคคลใช้บริการอยู่ รวมถึง
          เจ้าของข้อมูลจะไม่ได้รับข้อมูลข่าวสารอันเป็นสิทธิและประโยชน์ส่วนบุคคลของ SC และ บริษัทในเครือ รวมถึงบริษัทคู่ค้าของ SC
        </span>
      </li>
      <li>
        <strong>ติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล</strong>
        <span>
          สำนักตรวจสอบภายใน  สำนักงานเลขที่ 1010 ชั้น P13 ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร
          &nbsp;กรุงเทพมหานคร 10900 Email: dataprivacy@scasset.com
        </span>
      </li>
    </ol>
    <br />
    <h1 align="center">
      ข้อกำหนดและเงื่อนไขการเปิดและใช้บริการ Ruejai App<br />
      ของบริษัท เอสซี แอสเสท คอร์ปอเรชั่น จำกัด (มหาชน) และบริษัทในเครือ
    </h1>
    <p>&nbsp;</p>
    <p>
      <span style="font-weight: 400;"
        >ข้อตกลงและเงื่อนไขการใช้บริการ ตามที่ปรากฏในเอกสารฉบับนี้
        ใช้บังคับระหว่าง บริษัท &nbsp;&nbsp;&nbsp;&nbsp;เอสซี แอสเสท
        คอร์ปอเรชั่น จำกัด (มหาชน) และบริษัทในเครือ (ซึ่งต่อไปนี้จะเรียกว่า </span
      ><strong>&ldquo;ผู้ให้บริการ&rdquo;</strong
      ><span style="font-weight: 400;"
        >) กับ เจ้าของกรรมสิทธิ์ห้องชุด /เจ้าของบ้าน และ/หรือ บริวาร ผู้อาศัย
         ผู้เช่าในโครงการของผู้ให้บริการ และผู้ใช้งานทั่วไป (ซึ่งต่อไปนี้จะเรียกว่า </span
      ><strong>&ldquo;ผู้ใช้บริการ&rdquo;</strong
      ><span style="font-weight: 400;"
        >) ซึ่งได้รับการอนุญาตจากผู้ให้บริการให้ใช้บริการ</span
      ><strong> Ruejai App</strong
      ><span style="font-weight: 400;">
        ของผู้ให้บริการ โดยการใช้บริการต้องเป็นไปตามข้อกำหนดการใช้บริการ
        ซึ่งรวมถึงการแก้ไขเพิ่มเติมและนโยบายการดำเนินงานอื่นๆ
        ซึ่งผู้ให้บริการอาจกำหนดขึ้นเพิ่มเติมเป็นครั้งคราวตามดุลยพินิจของผู้ให้บริการแต่เพียงผู้เดียว </span
      ><strong>(&ldquo;ข้อกำหนดการใช้บริการ&rdquo;)</strong>
    </p>
    <p>
      <span style="font-weight: 400;"
        >นอกจากนี้
        ผู้ให้บริการขอสงวนสิทธิและดุลยพินิจแต่เพียงผู้เดียวในการแก้ไขเปลี่ยนแปลงข้อกำหนดการใช้บริการเป็นครั้งคราว
        ผู้ให้บริการจะแจ้งให้ท่านทราบถึงการแก้ไขเปลี่ยนแปลงดังกล่าวล่วงหน้าที่การแก้ไขเปลี่ยนแปลงดังกล่าวจะมีผลบังคับใช้และหลังจากนั้นการใช้บริการของผู้ใช้บริการภายหลังการแก้ไขเปลี่ยนแปลงดังกล่าวจะถือเป็นการตอบรับการใช้บริการตามที่ได้มีการแก้ไขเปลี่ยนแปลง
        หากมีคำถามที่เกี่ยวข้องกับข้อกำหนดการใช้บริการสามารถติดต่อได้ที่ SC
        ASSET Contact Centre โทรศัพท์หมายเลข 1749</span
      >
    </p>
    <p>&nbsp;</p>
    <ol>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;">ผู้ให้บริการเปิดให้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          สำหรับเจ้าของกรรมสิทธิ์ห้องชุด, เจ้าของบ้าน และ/หรือ บริวาร ผู้อาศัย
          และ ผู้เช่า ในโครงการของผู้ให้บริการ และ/หรือ
          บุคคลที่ผู้ให้บริการได้กำหนดในภายหลัง</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้สมัครใช้บริการจะต้องมี ชื่อ-นามสกุล, เบอร์โทรศัพท์มือถือ
          และบัตรประชาชน โดยมีเงื่อนไขอย่างน้อยต้องเป็นเจ้าของกรรมสิทธิ์ห้องชุด,
          เจ้าของบ้าน และ/หรือ บริวาร ผู้อาศัย ในโครงการของผู้ให้บริการ</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;">ผู้ใช้บริการสามารถเข้าใช้ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ได้ตลอด 24 ชั่วโมง ทั้งนี้
          ผู้ให้บริการขอสงวนสิทธิในการเปลี่ยนแปลงระยะเวลาของรายการต่างๆ ได้
          ตามแต่จะเห็นสมควร</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ในการเข้าสู่ระบบ ระบบจะทำการบังคับให้ ผู้ใช้บริการเข้า</span
        ><strong> Ruejai App</strong
        ><span style="font-weight: 400;">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ผ่านรหัสประจำตัวของผู้ใช้งาน Ruejai App
        </span>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >การแก้ไขข้อมูลผู้ใช้บริการซึ่งหมายถึงการลบ/เพิ่มข้อมูล,การแจ้งสิทธิ,แจ้งใช้บริการ,สอบถาม
          และแก้ไขข้อมูลส่วนตัวอื่นๆ ผ่านบริการ</span
        ><strong> Ruejai App</strong
        ><span style="font-weight: 400;">
          ทั้งที่เป็นการกระทำของผู้ใช้บริการเอง
          หรือเป็นการกระทำที่เกิดขึ้นโดยบุคคลอื่น ไม่ว่าโดยประการใดก็ตาม
          หากได้กระทำไปโดยการใช้รหัสผู้ใช้งาน/
          รหัสรักษาความปลอดภัยที่เกี่ยวข้องกับบริการนี้ ให้ถือว่าถูกต้องสมบูรณ์
          และให้มีผลผูกพันผู้ใช้บริการเสมือนหนึ่งได้กระทำโดยผู้ใช้บริการเอง
          และผู้ใช้บริการยินยอมรับผิดชอบในการกระทำดังกล่าวทุกประการ</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ใช้บริการตกลงและรับทราบว่า ในการเข้า</span
        ><strong> Ruejai App</strong
        ><span style="font-weight: 400;">
          ของผู้ให้บริการ
          &nbsp;&nbsp;&nbsp;&nbsp;อันเนื่องมาจากผู้ใช้บริการเองหรือบุคคลอื่นใดระบุรหัสผู้ใช้งานหรือรหัสรักษาความปลอดภัยหรือเหตุอื่นใดการที่รหัสผู้ใช้งานหรือรหัสผ่านถูกระงับด้วยระบบดังกล่าว
          จะส่งผลให้การรับบริการต่างๆ
          ที่ผู้ใช้บริการได้ทำไว้หรือตกลงให้ทำไว้ล่วงหน้า จะถูกระงับทันที
          และผู้ใช้บริการตกลงที่จะไม่เรียกร้องค่าเสียหายใดๆ
          ที่อาจเกิดขึ้นจากการระงับการบริการดังกล่าวกับผู้ให้บริการทั้งสิ้น</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ในกรณีที่เกิดผู้ใช้บริการพบข้อผิดพลาดจากการดำเนินการ
          หรือในกรณีที่มีเหตุที่ต้องระงับการดำเนินการภายใต้บริการนี้
          ผู้ใช้บริการจะต้องแจ้งให้ผู้ให้บริการทราบโดยเร็ว ที่ SC ASSET Contact
          Centre โทรศัพท์หมายเลข 1749 โดยอย่างน้อยต้องแจ้งข้อมูลเกี่ยวกับ
          ชื่อผู้ใช้บริการ วันและเวลาที่ทำรายการ
          โดยผู้ให้บริการและผู้ใช้บริการจะร่วมมือดำเนินการตรวจสอบหาสาเหตุของข้อผิดพลาด
          รวมถึงแก้ไขข้อผิดพลาดโดยเร็ว</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >หากความเสียหายเกิดขึ้นจากเครื่องมือ
          หรืออุปกรณ์การใช้บริการของผู้ใช้บริการ
          หรือเกิดจากระบบเครือข่ายโทรศัพท์มือถือ
          ผู้ให้บริการไม่ต้องรับผิดชอบต่อผู้ใช้บริการ</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ใช้บริการตกลงและยินยอมที่จะปฏิบัติตามเงื่อนไขและข้อกำหนดสำหรับการเข้าใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ของผู้ให้บริการ
          ตามที่ได้กำหนดในเอกสารนี้รวมถึงเงื่อนไขและข้อกำหนดอื่นใดที่จะจัดให้มีขึ้นในภายหน้า
          รวมถึงการปฏิบัติตามกฎหมายและกฎระเบียบต่าง ๆ
          ที่เกี่ยวข้องในการเข้าใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;"> ของผู้ให้บริการ</span>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >การกระทำใดๆ ที่เกี่ยวกับการเผยแพร่ ทั้งในรูปแบบของอีเมล และ/หรือ
          บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ของผู้ใช้บริการ
          ให้ถือเป็นการกระทำที่อยู่ภายใต้ความรับผิดชอบของผู้ใช้บริการแต่เพียงผู้เดียวผู้ให้บริการไม่มีส่วน
          เกี่ยวข้องใดๆ ทั้งสิ้น</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ใช้บริการต้องเก็บรหัสประจำตัวของผู้ใช้งานการให้บริการ
          ที่ได้รับไว้เป็นความลับ
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เพื่อป้องกันไม่ให้ผู้ที่ไม่เกี่ยวข้องเข้าสู่ระบบ
          เพื่อกระทำการใดๆ อันอาจจะก่อให้เกิดความเสียหายแก่สมาชิกเอง
        </span>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ใช้บริการตกลงให้ผู้ให้บริการใช้ข้อมูลของผู้ใช้บริการ
          เพื่อการพิจารณาและดำเนินการเสนอผลิตภัณฑ์ บริการ
          และข้อเสนอพิเศษอื่นให้แก่ผู้ใช้บริการ และ/หรือ เพื่อการอื่นได้</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ในกรณีที่ระบบการติดต่อสื่อสารขัดข้องเป็นเหตุให้ผู้ใช้บริการไม่สามารถเข้าใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ของผู้ให้บริการได้ ผู้ใช้บริการตกลงจะไม่ยกเอาเหตุขัดข้องดังกล่าว
          เป็นข้อเรียกร้องค่าทดแทนหรือค่าเสียหายใด ๆ จากผู้ให้บริการ</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ห้ามนำข้อมูลที่ได้รับ ไปใช้ในทางที่ก่อให้เกิดความเดือดร้อนแก่ผู้อื่น
          เช่น โพสต์ข้อความที่ &nbsp;ไม่ชอบด้วยกฎหมาย ข้อความที่ไม่สุภาพ
          โฆษณาประชาสัมพันธ์ข้อมูล ข่าวสาร ที่ก่อให้เกิดความรำคาญแก่บุคคลอื่น
          หรือก่อให้เกิดการเข้าใจผิด ลงในแหล่งข้อมูลที่เป็นสาธารณะ เช่น
          ตามกระดานข่าวของเว็บไซต์ต่างๆ หรือบนโซเชียลมีเดียต่างๆ เช่น
          Facebook</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ห้ามผู้ใช้บริการกระทำการใดๆ ที่อาจจะนำมาซึ่งความเสื่อมเสีย
          หรือก่อให้เกิดความเสียหายแก่ระบบ</span
        ><strong> Ruejai App</strong
        ><span style="font-weight: 400;"> โดยรวม</span>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ห้ามผู้ใช้บริการใช้บริการนี้ในการเก็บและเผยแพร่ข้อมูล ที่ทำซ้ำ
          ดัดแปลง ข้อมูลใดๆ ที่เข้าข่ายละเมิดลิขสิทธิ์
          หรือใช้บริการนี้ในการเก็บข้อมูล หรือให้บริการใดๆ แก่เว็บไซต์อื่น</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ให้บริการสงวนสิทธิที่จะดำเนินคดีตามกฏหมายสูงสุดกับบุคคลใดๆ
          ที่พยายาม กระทำการที่เป็นอันตรายแก่ระบบ</span
        ><strong> Ruejai App</strong>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ให้บริการขอสงวนสิทธิในการเปลี่ยนแปลงข้อกำหนดและเงื่อนไขการใช้บริการต่าง
          ๆ ได้ตามแต่จะเห็นสมควร นอกจากนี้ผู้ให้บริการมีสิทธิ
          ที่จะยกเลิกบริการดังกล่าวนี้ได้
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ไม่ว่าทั้งหมดหรือบางส่วน
          หรือเฉพาะแต่ผู้ใช้บริการรายใดรายหนึ่งเมื่อใดก็ได้ โดย
          ผู้ให้บริการจะแจ้งให้ทราบล่วงหน้าก่อนมีผลบังคับใช้
          หรือตามระยะเวลาและเงื่อนไขที่มีกฎหมายกำหนดไว้
        </span>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ให้บริการสงวนสิทธิในการใช้ข้อมูล และ หรือเปิดเผยข้อมูลของสมาชิก
          เมื่อได้รับการร้องขอจากเจ้าหน้าที่บ้านเมือง</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ให้บริการสงวนสิทธิที่จะยกเลิกบริการนี้ทันที
          เมื่อพบว่าสมาชิกละเมิดข้อตกลง หรือพบว่าการกระทำนั้นๆ
          อาจจะก่อให้เกิดหรือเป็นอันตรายต่อ</span
        ><strong> Ruejai App</strong
        ><span style="font-weight: 400;">
          โดยรวม เช่น การละเมิดระบบรักษาความปลอดภัย การพยายามเจาะระบบ
          หรือพยายามเข้าถึงข้อมูลของเซิร์ฟเวอร์และข้อมูลสมาชิกอื่น หรือทำการใดๆ
          ที่ทำให้เกิดภาระหนักแก่</span
        ><strong> Ruejai App</strong
        ><span style="font-weight: 400;">
          ทางผู้ให้บริการ จะถือว่าผู้ใช้บริการทุกท่านได้อ่านและเข้าใจใน ข้อตกลง
          และระเบียบ
          ในการใช้บริการนี้เป็นอย่างดีแล้วจึงได้สมัครใช้บริการจากทางผู้ให้บริการ</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >กรณีที่ผู้ให้บริการได้รับการร้องเรียน ร้องขอหรือพบเห็นการกระทำใดๆ
          อันอาจก่อให้เกิดความเสียหายในการให้บริการระบบ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ผู้ให้บริการสงวนสิทธิที่จะทำการยกเลิกหรือระงับบริการ แก่สมาชิกนั้นๆ
          เป็นการชั่วคราวเพื่อทำการสอบสวน
          และตรวจสอบหาสาเหตุของมูลเหตุนั้นๆ</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ให้บริการมีสิทธิไม่รับผิดชอบเกี่ยวกับประสิทธิภาพ ความล่าช้า
          ความผิดพลาด การสูญเสียข้อมูล อันเกี่ยวกับการใช้ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;"> นี้ </span>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ให้บริการไม่จำเป็นต้องติดตามหรือตรวจสอบการเข้าบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          หรือการใช้บริการ อย่างไรก็ตาม
          ผู้ให้บริการอาจติดตามหรือตรวจสอบเป็นครั้งคราวเพื่อวัตถุประสงค์ของผู้ให้บริการเอง
          หรือเมื่อผู้ให้บริการต้องดำเนินการตามที่ระบุในข้อกำหนดการใช้บริการนี้
          ในการติดตามหรือตรวจสอบนี้
          ผู้ให้บริการขอสงวนสิทธิในการแก้ไขหรือลบเนื้อหาซึ่งฝ่าฝืนข้อกำหนดการใช้บริการนี้โดยไม่ต้องแจ้งล่วงหน้าและไม่ต้องรับผิดชอบแต่อย่างใด</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >แม้ว่าในขณะนี้ ไม่มีการคิดค่าบริการการใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          นี้ ผู้ใช้บริการตกลงและรับทราบว่า
          ผู้ให้บริการขอสงวนสิทธิแต่เพียงผู้เดียวในการคิดค่าบริการการใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          หรือบริการที่อาจให้ไว้ในนี้ หรือส่วนใดส่วนหนึ่งในอนาคต
          โดยผู้ให้บริการจะแจ้งค่าบริการดังกล่าวให้ผู้ใช้บริการทราบล่วงหน้านอกเหนือจากและโดยไม่คำนึงถึงข้อกำหนดดังกล่าว
          ผู้ใช้บริการตกลงและรับทราบว่าอาจมีบริการบางอย่างในนี้
          ไม่ว่าจะให้บริการอยู่ในขณะนี้หรืออาจให้บริการต่อไปในอนาคตที่จำเป็นต้องให้ผู้ใช้บริการลงทะเบียนกับผู้ให้บริการเพื่อเข้าหรือใช้งาน
          ในกรณีดังกล่าว
          ผู้ใช้บริการตกลงและยอมรับว่าผู้ให้บริการขอสงวนสิทธิแต่เพียงผู้เดียวในการคิดค่าบริการการลงทะเบียนดังกล่าวและ/หรือการเข้าใช้และการใช้บริการดังกล่าวหรือส่วนใดส่วนหนึ่งของบริการดังกล่าว
          และเพื่อให้เป็นไปตามวัตถุประสงค์ดังกล่าวนี้
          ผู้ใช้บริการจะได้รับแจ้งให้ทราบค่าบริการต่างๆที่เกี่ยวข้อง
          เมื่อมีการลงทะเบียนและขั้นตอนการลงทะเบียนเสร็จสิ้นสมบูรณ์
          การเข้าใช้หรือการใช้บริการดังกล่าวของผู้ใช้บริการจะถือเป็นการตอบรับการใช้บริการที่มีผลผูกมัด</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ให้บริการมีนโยบายเคารพความลับของข้อมูลที่ผู้ใช้บริการได้เปิดเผยไว้จากการใช้บริการ</span
        ><strong> Ruejai App</strong
        ><span style="font-weight: 400;"> นี้และการใช้บริการในนี้ (&ldquo;</span
        ><strong>ข้อมูลความลับ</strong
        ><span style="font-weight: 400;"
          >&rdquo;) ดังนั้น
          ผู้ให้บริการจะไม่แก้ไขหรือเปิดเผยข้อมูลความลับของผู้ใช้บริการ
          เว้นแต่จำเป็นต้องทำเพื่อให้เป็นไปตามพระราชบัญญัติ กฎหมาย
          และระเบียบข้อบังคับ เพื่อปกป้องสิทธิและทรัพย์สินของผู้ให้บริการ
          และการบังคับใช้ข้อกำหนดการใช้บริการนี้เพื่อให้บริการในนี้
          และเพื่อตอบโต้ข้อกล่าวหาว่าเนื้อหาได้ละเมิดสิทธิของบุคคลอื่นหรือตามแต่ที่จะได้ระบุไว้ที่อื่นในข้อกำหนดฉบับนี้
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;โดยไม่คำนึงถึงข้อกำหนดข้างต้น
          ผู้ให้บริการอาจเปิดเผยข้อมูลความลับของผู้ใช้บริการในบางครั้ง
          (เฉพาะโดยรวมหรือที่เกี่ยวกับสถิติ) แก่ผู้ให้บริการภายนอก ผู้โฆษณา
          บริษัทร่วม บริษัทในเครือ หรือฝ่ายอื่นที่เกี่ยวข้องเพื่อใช้เป็นบันทึก
          ข้อมูลอื่นๆเกี่ยวกับวิธีที่การที่ผู้ให้บริการดูแลรักษาข้อมูลความลับของท่านได้ระบุอยู่ในนโยบายความเป็นส่วนตัว</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ใช้บริการตกลงรับผิดชดใช้ค่าเสียหายเต็มจำนวน
          จากการละเมิดข้อกำหนดการใช้บริการนี้ของผู้ใช้บริการ และเป็นเหตุให้
          ผู้ให้บริการ เจ้าหน้าที่ กรรมการ พนักงาน หรือ ตัวแทนของ
          &nbsp;ผู้ให้บริการได้รับความเสียหาย ไม่ว่าโดยตรงหรือโดยอ้อม
        </span>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ในกรณีที่ผู้ให้บริการไม่สามารถหรือปฏิเสธที่จะบังคับใช้ข้อกำหนดหรือดำเนินการแก้ไขใดๆ
          ภายใต้ข้อกำหนดการใช้บริการนี้ไม่ว่าด้วยเหตุผลใดก็ตาม
          มิได้หมายความว่าผู้ให้บริการได้สละสิทธิในการบังคับใช้ข้อกำหนดหรือการแก้ไขใดๆที่เหมือนกันนี้
          หรือสละสิทธิของผู้ให้บริการในการละเมิดเดียวกันนี้ที่ยังดำเนินอยู่
          ที่ตามมา หรือที่เกิดขึ้นภายหลัง
          หรือข้อกำหนดอื่นใดในข้อกำหนดการเข้าใช้นี้</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ผู้ใช้บริการตกลงว่าข้อกำหนดการใช้บริการนี้
          การดำเนินการและผลการดำเนินการภายใต้ข้อกำหนดการใช้บริการนี้
          การเข้าใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          และการใช้บริการในนี้
          และ/หรือเนื้อหาและข้อขัดแย้งที่เกิดขึ้นจากการใช้บริการนั้นจะต้องอยู่ภายใต้บังคับและตีความตามกฎหมายของประเทศไทย
          นอกจากนี้
          ผู้ใช้บริการตกลงที่จะปฏิบัติตามและผูกมัดโดยขอบเขตอำนาจของศาลไทยการปฏิบัติหน้าที่ของผู้ให้บริการภายใต้ข้อกำหนดการใช้บริการจะเป็นไปตามพระราชบัญญัติ
          กฎหมาย และระเบียบข้อบังคับที่มีอยู่
          &nbsp;ซึ่งเกี่ยวข้องกับเรื่องเดียวกันนี้
          และไม่มีส่วนใดในข้อกำหนดการใช้บริการที่จะยกเลิกสิทธิของผู้ให้บริการในการปฏิบัติตามคำร้องขอของรัฐบาลหรือระเบียบข้อกำหนดทางกฎหมาย
          ที่เกี่ยวข้องกับการเข้าถึงบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          และการใช้บริการในนี้หรือที่เกี่ยวข้องกับเนื้อหาหรือส่วนใดส่วนหนึ่งของเนื้อหาที่ได้จัดให้หรือที่ผู้ให้บริการได้จัดหาเพื่อการใช้งานของผู้ใช้บริการ</span
        >
      </li>
    </ol>
    <br /><br /><br />
    <h2 align="center">
      การสมัครและการลงทะเบียนบริการ Ruejai App
    </h2>
    <p>
      <strong> &ldquo;สัญญา&rdquo;</strong
      ><span style="font-weight: 400;">
        หมายถึง ข้อกำหนดและเงื่อนไขของสัญญาบริการ </span
      ><strong>Ruejai App</strong
      ><span style="font-weight: 400;">
        ตามที่ระบุในนี้ ซึ่งอาจเปลี่ยนแปลงได้เป็นครั้งคราว</span
      >
    </p>
    <p>
      <strong> &ldquo;บริการของบริษัท&rdquo;</strong
      ><span style="font-weight: 400;">
        หมายถึง ผลิตภัณฑ์และบริการที่ได้ระบุไว้ที่นี้หรืออาจจัดหาให้โดยบริษัท
        และ/หรือบริษัทในเครือและบริษัทร่วมเป็นครั้งคราว</span
      >
    </p>
    <p>
      <strong>&ldquo;บริษัท&rdquo; </strong
      ><span style="font-weight: 400;"
        >หมายถึง บริษัท เอสซี แอสเสท คอร์ปอเรชั่น จำกัด (มหาชน)
        และรวมถึงบริษัทในเครือและผู้รับโอน</span
      >
    </p>
    <p>
      <strong>&ldquo;Ruejai App&rdquo;</strong
      ><span style="font-weight: 400;">
        หมายถึง บริการของบริษัทที่นำเสนอโดยบริษัท
        เพื่อสนับสนุนและ/หรือให้บริการหลังการขายให้แก่ลูกค้าของบริษัท
        ภายหลังการรับโอนกรรมสิทธ์ห้องชุด และ/หรือบ้าน
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ในโครงการของบริษัท
        ผ่านระบบอิเล็กทรอนิกส์
        เพื่อเพิ่มความสะดวกรวดเร็วในการสื่อสารและการให้บริการหลังการขายระหว่างบริษัทกับคู่ค้า
        ซึ่งจะนำพาซึ่งประสิทธิภาพและก่อประสิทธิผลในการให้บริการระหว่างกัน
      </span>
    </p>
    <p>
      <strong>
        &ldquo;รหัสประจำตัวผู้ใช้งาน Ruejai App&rdquo;</strong
      ><span style="font-weight: 400;"> หมายถึง รหัสประจำตัวผู้ใช้บริการ </span
      ><strong>(User Name)</strong
      ><span style="font-weight: 400;"> และรหัสผ่านระบบ </span
      ><strong>(Password)</strong
      ><span style="font-weight: 400;">
        ของผู้ใช้บริการ
        เพื่อพิสูจน์รับรองและพิสูจน์ตัวตนก่อนอนุญาตให้ท่านเข้าใช้บริการ </span
      ><strong>Ruejai App</strong
      ><span style="font-weight: 400;"> ได้</span>
    </p>
    <p>
      <strong> &ldquo;คำสั่ง&rdquo;</strong
      ><span style="font-weight: 400;">
        หมายถึง การขอ การสมัคร การอนุญาต
        หรือคำสั่งไม่ว่าในรูปแบบใดที่ผู้ใช้บริการหรือบุคคลอื่นที่อ้างว่าเป็นท่าน
        ไม่ว่าจะได้รับมอบอำนาจหรือไม่ก็ตาม ที่ได้ให้ไว้หรือส่งผ่านบริการ </span
      ><strong>Ruejai App</strong
      ><span style="font-weight: 400;"> มายังบริษัท</span>
    </p>
    <p>
      <strong> &ldquo;เจ้าหน้าที่&rdquo;</strong
      ><span style="font-weight: 400;">
        หมายถึง เจ้าหน้าที่ พนักงาน หรือผู้ให้บริการของบริษัท</span
      >
    </p>
    <ul>
      <li>
        <strong
          >ขั้นตอนการสมัครและการลงทะเบียนบริการ Ruejai App</strong
        >
      </li>
    </ul>
    <ol>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;">บริการ</span
        ><strong> Ruejai App</strong
        ><span style="font-weight: 400;">
          นี้เปิดให้ลูกค้าซึ่งเป็นเจ้าของกรรมสิทธิ์ห้องชุด
          และ/หรือเจ้าของบ้านพักอาศัย รวมทั้ง บริวาร ผู้พักอาศัย และ ผู้เช่า
          ที่อยู่ในโครงการบ้านหรือคอนโดมิเนียมของบริษัท และลงทะเบียนเข้าใช้ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          โดยต้องเป็นไปตามข้อกำหนดและเงื่อนไขในนี้</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;">การสมัครขอใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          และการเข้าใช้นั้นต้องอยู่ในดุลยพินิจของบริษัท
          และบริษัทขอสงวนสิทธิที่จะรับหรือปฏิเสธการสมัคร ปฏิเสธการเข้าใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ของท่าน หรือบริษัทอาจจำกัดการเข้าใช้หรือธุรกรรม
          หรือยกเลิกการเข้าใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          โดยไม่จำเป็นต้องให้เหตุผลการปฏิเสธหรือตอบรับคำขอข้อมูลของท่าน</span
        >
      </li>
    </ol>
    <ul>
      <li><strong>การยอมรับข้อกำหนดและเงื่อนไข</strong></li>
    </ul>
    <ol>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ท่านรับทราบว่าครั้งแรกที่ท่านสมัครเข้าใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          นั้น ให้ถือว่าท่านได้อ่าน เข้าใจ
          และตกลงที่จะปฏิบัติตามข้อกำหนดและเงื่อนไขของสัญญานี้
          และท่านยังรับทราบและยอมรับความเสี่ยงที่เกี่ยวกับการทำธุรกรรมใดๆทางโทรศัพท์หรือสื่ออิเล็กทรอนิกส์อื่นๆ
          โดยบริษัท</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ท่านตกลงที่จะปฏิบัติตามข้อกำหนดและเงื่อนไขของสัญญานี้ในการเข้าและใช้บริการ</span
        ><strong> Ruejai App</strong
        ><span style="font-weight: 400;"> ของบริษัท</span>
      </li>
    </ol>
    <ul>
      <li>
        <strong>ความรับผิดชอบสำหรับรหัสประจำตัวในการใช้งานบริการ Ruejai App</strong>
      </li>
    </ul>
    <ol>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ท่านตกลงและรับทราบว่าท่านจะเก็บรหัสประจำตัวผู้ใช้งานบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ไว้เป็นความลับและไม่ใช้ร่วมกับบุคคลอื่นหรือเปิดเผย
          ต่อบุคคลอื่นไม่ว่าด้วยเหตุผลใด รวมถึงเจ้าหน้าที่บริษัท</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ท่านตกลงว่าท่านจะรับผิดชอบการเข้าใช้และ/หรือการใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ทั้งหมดที่กระทำผ่านรหัสประจำตัวผู้ใช้งานบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ของท่านตลอดเวลา
          ไม่ว่าจะเป็นการดำเนินการโดยท่านหรือบุคคลอื่นที่อ้างว่าเป็นท่าน</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >หลังจากที่บริษัทได้รับแจ้งจากท่านตามข้อ 3.2 ข้างต้น
          ท่านตกลงและรับทราบว่าบริษัท
          อาจใช้สิทธิและดุลยพินิจของบริษัทในการระงับการเข้าใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ของท่านจนกว่าจะมีการให้รหัสประจำตัวผู้ใช้งานบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;"> ได้รับการแก้ไขโดยบริษัท แล้ว</span>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >โดยไม่คำนึงถึงเงื่อนไขต่างๆในนี้และเพื่อไม่ให้เกิดข้อสงสัย
          หากมีการใช้รหัสประจำตัวผู้ใช้งานบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ของท่านโดยไม่ได้รับอนุญาตซึ่งเกิดจากการกระทำของท่าน การทุจริต
          การเปิดเผย การใช้ในทางที่ผิดหรือโดยมิชอบ อย่างจงใจ
          ท่านต้องรับผิดชอบการใช้ดังกล่าวแม้ว่าจะได้ทำการแจ้งไว้ตามข้อ 3.3
          ข้างต้นแล้วก็ตาม</span
        >
      </li>
    </ol>
    <ul>
      <li><strong>คำสั่งและการอนุญาต</strong></li>
    </ul>
    <ol>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ท่านต้องรับผิดชอบคำสั่งทั้งหมดที่ส่งมายัง</span
        ><strong> Ruejai App</strong
        ><span style="font-weight: 400;">
          โดยผ่านรหัสประจำตัวผู้ใช้งานบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ของท่านตลอดเวลาไม่ว่าคำสั่งเหล่านั้นจะถูกทำขึ้นโดยท่านหรือคนอื่นที่อ้างว่าเป็นท่าน
          และท่านได้ตกลงและยอมรับว่าบริษัทมีสิทธิที่จะใช้และปฏิบัติตามคำสั่งที่ได้ทำหรือส่งตามการใช้และการเข้ารหัสประจำตัวผู้ใช้งานบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ที่ท่านได้ทำหรือส่ง
          และด้วยเหตุนี้บริษัทจะไม่รับผิดชอบหรือรับผิดในความสูญเสียใดๆที่ท่านอาจได้รับ
          ไม่ว่าโดยทางตรงหรือทางอ้อมอันเกิดจากคำสั่งดังกล่าว</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >คำสั่งทั้งหมดที่ส่งมายังและ/หรือรับโดยบริษัทผ่านรหัสประจำตัวผู้ใช้งานบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ของท่านจะถือเป็นคำสั่งตามปกติและจริงแท้ที่ท่านทำขึ้น
          &nbsp;&nbsp;&nbsp;เพื่อไม่ให้เกิดข้อสงสัย
          บริษัทไม่จำเป็นต้องพิสูจน์รับรองคำสั่งดังกล่าวกับท่านเพื่อระบุความถูกต้อง
          แต่บริษัทอาจใช้สิทธิและวิจารณญาณดำเนินการพิสูจน์รับรองเพื่อวัตถุประสงค์ของบริษัทเอง</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >คำสั่งทั้งหมดที่ส่งผ่านรหัสประจำตัวผู้ใช้งานบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          อยู่ในความรับผิดชอบของท่าน หากท่านประสงค์จะแก้ไข เปลี่ยนแปลง
          ต้องดำเนินการแจ้งที่ &nbsp;&nbsp;&nbsp;&nbsp;SC ASSET Contact Centre
        </span>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ท่านอนุญาตให้บริษัทรับและปฏิบัติตามคำสั่งที่ท่านได้ทำขึ้นที่เกี่ยวกับบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ที่ท่านทำขึ้นผ่านรหัสประจำตัวผู้ใช้งานบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          ของท่าน
          ไม่ว่าคำสั่งนั้นจะทำขึ้นโดยท่านเองหรือบุคคลอื่นที่อ้างเป็นท่าน</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >หากท่านพบหรือมีเหตุผลที่เชื่อได้ว่าคำสั่งที่ส่งให้หรือรับโดยบริษัท
          ไม่ถูกต้องหรือไม่สมบูรณ์ ท่านจะแจ้งให้บริษัททราบ โดยโทรศัพท์แจ้งที่ SC
          ASSET Contact Centre และเพื่อไม่ให้เกิดข้อสงสัย
          ทุกสายโทรศัพท์ที่โทรเข้ามายัง SC ASSET Contact Centre ของบริษัท
          จะถูกบันทึกไว้โดยบริษัท</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >บริษัทจะต้องไม่ถูกบังคับให้ทำหน้าที่ขอยกเลิก เพิกถอน
          แก้กลับหรือแก้ไขคำสั่งใดๆ สำหรับใช้บริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;">
          หรือคำสั่งอื่นๆ หลังจากที่บริษัทได้รับคำสั่งจากท่านแล้ว
          อย่างไรก็ตามบริษัทอาจยกเลิก เพิกถอน แก้กลับ หรือแก้ไขคำสั่งก่อนหน้านี้
          หากคำขอยกเลิก เพิกถอน แก้กลับ
          หรือแก้ไขนั้นได้รับและมีผลบังคับใช้ก่อนดำเนินการตามคำสั่งนี้ก่อนหน้านี้
        </span>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >ในกรณีที่บริษัทตัดสินใจที่จะปฏิบัติตามและ/หรือดำเนินการตามคำสั่งหรือจำเป็นต้องปฏิบัติตามและ/หรือดำเนินการตามคำสั่ง
          บริษัทจะมีเวลาในการปฏิบัติตามและดำเนินการตามคำสั่งตามสมควรโดยคำนึงถึงระบบ
          และการปฏิบัติการของบริษัทและสถานการณ์อื่นๆที่เกิดขึ้นในขณะนั้น
          และด้วยเหตุนี้บริษัทจะไม่รับผิดชอบหรือไม่รับผิดสำหรับความสูญเสียที่เกิดขึ้นจากความล่าช้าในส่วนของบริษัทในการปฏิบัติตามและ/หรือดำเนินการตามคำสั่งดังกล่าว</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >กรณีที่คำสั่งคลุมเครือและ/หรือไม่สอดคล้องกับคำสั่งอื่น บริษัท
          มีสิทธิที่จะใช้และปฏิบัติตามคำสั่งนี้ตามการตีความอย่างสมเหตุสมผล
          ซึ่งเจ้าหน้าที่เชื่อโดยสุจริตว่าเป็นการตีความที่ถูกต้อง
          หรือปฏิเสธที่จะปฏิบัติตามคำสั่งจนกว่าบริษัท
          จะได้รับคำสั่งใหม่ในรูปแบบและลักษณะตามที่บริษัทกำหนด</span
        >
      </li>
    </ol>
    <ul>
      <li><strong>บริการ Ruejai App</strong></li>
    </ul>
    <ol>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >บริษัทให้บริการดังต่อไปนี้แก่ท่าน
          โดยต้องเป็นไปตามข้อกำหนดและเงื่อนไขของสัญญานี้และข้อกำหนดและเงื่อนไขอื่นๆที่อาจเกี่ยวข้องกับบริการของบริษัทหนึ่งๆ
          และท่านต้องมีและครอบครองหรือพักอาศัยกับโครงการใดๆที่ทำผ่านบริการ </span
        ><strong>Ruejai App</strong
        ><span style="font-weight: 400;"> ไว้</span>
      </li>
      <ol>
        <li style="font-weight: 400;">
          <span style="font-weight: 400;"
            >การเข้าถึงข้อมูลโครงการต่างๆ ของบริษัท</span
          >
        </li>
        <li style="font-weight: 400;">
          <span style="font-weight: 400;"
            >ข่าวสารและสิทธิประโยชน์ต่างๆ เพื่อลูกค้าของบริษัท</span
          >
        </li>
        <li style="font-weight: 400;">
          <span style="font-weight: 400;"
            >ช่องทางการติดต่อสื่อสารที่พร้อมให้บริการ ตลอด 24 ชั่วโมง</span
          >
        </li>
        <li style="font-weight: 400;">
          <span style="font-weight: 400;"
            >แจ้งซ่อมแซมความเสียหายของห้องชุด/บ้านในระยะเวลารับประกัน</span
          >
        </li>
        <li style="font-weight: 400;">
          <span style="font-weight: 400;"
            >บริการของบริษัทแบบใหม่อื่นๆที่นำเสนอโดยบริษัท หรือบริษัทในเครือ
            บริษัทร่วม หรือบุคคลภายนอกเป็นครั้งคราว
            ด้วยการใช้บริการทางบริษัทแบบใหม่ที่นำเสนอนี้
            ท่านตกลงที่จะมีผลผูกพันทางสัญญาที่เกี่ยวกับบริการของบริษัทแบบใหม่นี้เท่าที่สัญญาจะมีผลใช้บังคับ</span
          >
        </li>
      </ol>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >กรณีที่ได้มีการแนะนำบริการของบริษัทใหม่นี้ตามข้อ 5.1.5 ข้างต้น
          ท่านตกลงและยอมรับว่าในการใช้บริการของบริษัทใหม่นี้
          ท่านจะต้องปฏิบัติตามข้อกำหนดและเงื่อนไขที่ใช้บังคับบริการของบริษัทใหม่นี้</span
        >
      </li>
    </ol>
    <ul>
      <li>
        <strong>ข้อความ คำยืนยัน และคำแนะนำ</strong><br />
        กรณีที่บริษัทส่งหรือมอบข้อความคำยืนยันหรือคำแนะนำ
        ท่านต้องตรวจสอบข้อความคำยืนยัน หรือคำแนะนำ
        และแจ้งบริษัทอย่างเป็นลายลักษณ์อักษรเกี่ยวกับข้อผิดพลาดหรือการละเว้นต่างๆในข้อความ
        คำยืนยัน หรือคำแนะนำภายใน 7 วันนับจากวันที่ในข้อความ คำยืนยัน ข้างต้น
        หากบริษัท ไม่ได้รับแจ้งดังกล่าวภายใน 7 วัน ข้อความ คำยืนยัน
        และคำแนะนำดังกล่าวจะถือเป็นจริงและถูกต้อง
      </li>
    </ul>
    <ul>
      <li>
        <strong>การปรับปรุงข้อมูลลูกค้าให้เป็นปัจจุบัน</strong><br />
        ท่านต้องแจ้งบริษัทอย่างเป็นลายลักษณ์อักษรหรือโดยวิธีอื่นๆในทันทีเนื่องจากถือว่าบริษัทต้องรับผิดชอบการเปลี่ยนแปลงหรือความแตกต่างใดๆในข้อมูลส่วนบุคคล
        และบริษัทมีสิทธิที่จะถือว่าข้อมูลไม่มีการเปลี่ยนแปลงหรือความแตกต่างใดๆจนกว่าบริษัทจะได้รับแจ้งจากท่าน
        การให้ข้อมูลระหว่างขั้นตอนการสมัครในบริการ
        <strong>Ruejai App</strong>
        ไม่ถือเป็นการปรับปรุงข้อมูลส่วนบุคคลของท่านโดยอัตโนมัติ
      </li>
    </ul>
    <br><br><br>
    <p>แก้ไขล่าสุดเมื่อ: 21 พฤษภาคม 2563</p>
  </div>
</template>

<script>
export default {
  name: 'PolicyTermsPage',
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
#terms-of-service {
  padding: 5%;
  height: 100%;
  overflow-y: scroll;

  h3,
  h4,
  h5,
  h6 {
    text-align: left;
  }

  p {
    margin-top: 10px;
  }

  ul,
  ol {
    color: #000;
    margin-top: 8px;
  }

  li {
    text-align: left;

    p {
      line-height: 1.6rem;
      color: inherit;
    }
  }
}

@media screen and (max-width: 420px) {
  h1 {
    font-size: 2rem;
  }
}
</style>
